import { FC } from 'react'
import { styled } from '../../lib/stitches'
import { Box, Row } from '../core/Components'
import { gray4 } from '../platform/color'
import { Skeleton as StyledSkeleton } from '../studio/discover-stems/StemRow'
import { PlayerBody, PlayerContainer, PlayerFooter, PlayerHeader } from './Player'

const Container = styled('div', {})

const Skeleton = styled(StyledSkeleton, {
  background: gray4
})

export const SampleSkeletonPlayer: FC = () => (
  <PlayerContainer>
    <PlayerHeader>
      <Row css={{ alignItems: 'center' }}>
        <Skeleton css={{ borderRadius: '10px', width: '56px', height: '56px' }} />
        <Box css={{ marginLeft: '12px' }}>
          <Skeleton css={{ width: '100px', height: '16px', margin: '2px 0px' }} />
          <Skeleton css={{ width: '70px', height: '14px', margin: '4px 0px' }} />
        </Box>
      </Row>
    </PlayerHeader>
    <PlayerBody>
      <Skeleton css={{ flex: 1 }} />
    </PlayerBody>
    <PlayerFooter>
      <Skeleton css={{ height: '4px', marginTop: '4px', marginBottom: '4px' }} />
      <Container
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '4px'
        }}
      >
        <Skeleton css={{ width: '34px', height: '12px' }} />
        <Skeleton css={{ width: '34px', height: '12px' }} />
      </Container>
      <Container css={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Skeleton css={{ width: '32px', height: '32px', borderRadius: '9999px' }} />
        <Skeleton
          css={{
            width: '48px',
            height: '48px',
            borderRadius: '9999px',
            marginLeft: '12px',
            marginRight: '12px'
          }}
        />
        <Skeleton css={{ width: '32px', height: '32px', borderRadius: '9999px' }} />
      </Container>
    </PlayerFooter>
  </PlayerContainer>
)

export const SongPlayerSkeleton: FC = () => (
  <PlayerContainer>
    <PlayerHeader>
      <Skeleton css={{ width: '28px', height: '28px', margin: '2px' }} />
      <Container>
        <Skeleton css={{ width: '100px', height: '16px', marginBottom: '4px' }} />
        <Skeleton css={{ width: '80px', height: '12px', margin: 'auto' }} />
      </Container>
      <Skeleton css={{ width: '32px', height: '32px', borderRadius: '9999px' }} />
    </PlayerHeader>
    <PlayerBody>
      <Skeleton css={{ flex: 1 }} />
    </PlayerBody>
    <PlayerFooter>
      <Skeleton css={{ height: '4px', marginTop: '4px', marginBottom: '4px' }} />
      <Container
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '12px',
          marginTop: '4px'
        }}
      >
        <Skeleton css={{ width: '34px', height: '12px' }} />
        <Skeleton css={{ width: '34px', height: '12px' }} />
      </Container>
      <Container css={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Skeleton css={{ width: '32px', height: '32px', borderRadius: '9999px' }} />
        <Skeleton
          css={{
            width: '48px',
            height: '48px',
            borderRadius: '9999px',
            marginLeft: '12px',
            marginRight: '12px'
          }}
        />
        <Skeleton css={{ width: '32px', height: '32px', borderRadius: '9999px' }} />
      </Container>
    </PlayerFooter>
  </PlayerContainer>
)
